<template>
  <v-dialog v-model="audit_log_dialog" scrollable max-width="900px" persistent>
    <v-form>
      <v-card>
        <v-toolbar color="white" fixed>
          <h3>{{ label }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container dense>
          <v-simple-table dense>
            <thead class="thead">
              <tr>
                <th class="text-center">{{ $i18n.t("By") }}</th>
                <th class="text-center">{{ $i18n.t("Field") }}</th>
                <th class="text-center">{{ $i18n.t("Old Value") }}</th>
                <th class="text-center">{{ $i18n.t("Changed To") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(na, index) in auditLogs.rows"
                :key="'audit_log_tr_' + index"
              >
                <th>
                  <span>{{ na.by }}</span
                  ><br />
                  <span
                    ><v-icon>mdi-clock</v-icon
                    >{{ na.at | moment("DD MMM YYYY hh:mm a") }}</span
                  >
                </th>
                <td colspan="3">
                  <v-simple-table dense style="width:100%">
                  <tbody>
                    <tr
                      v-for="(change, index1) in na.changes"
                      :key="'audit_log_tr_td_tbody' + index1"
                    >
                      <td class="text-left" style="width:33%">{{ change.field }}</td>
                      <td class="text-left" style="width:33%">{{ change.old }}</td>
                      <td class="text-left" style="width:33%">{{ change.modified }}</td>
                    </tr>
                  </tbody>
                  </v-simple-table>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPost, doGet } from "@/store/common/module/apis";
import corpService from "@/store/common/module/CorpService";

@Component({
  name: "AuditLog",
  props: {
    showDialog: {
      default: false,
    },
    entity_id: {
      default: null,
    },
    entity: {
      default: null,
    },
    label: {
      default: "Audit Logs",
    },
  },
})
export default class AuditLog extends Vue {
  auditLogs = [];
  audit_log_dialog = false;

  async getData() {
    this.auditLogs = await doGet(
      `/api/audit/${this.entity}/${this.entity_id}/grid`
    );
  }

  async mounted() {
    //this.getData();
  }

  get loading() {
    return common.loading;
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.audit_log_dialog = val;
    this.getData();
  }

  closeDialog() {
    this.audit_log_dialog = false;
    this.$emit("closeAuditLog", null);
  }
}
</script>
